import styled from 'styled-components'

export const ContainerCusto = styled.div`
  height: 89.7vh;
  overflow-y: hidden;
`
